/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * External trade registration request
 */
export interface ExternalTradeRegistration {
  /**
   * Account ID.
   */
  accountId: number;
  /**
   * Liquidity Provider ID.
   */
  lpId: number;
  /**
   * Base asset ID.
   */
  baseAssetId: number;
  /**
   * Quote asset ID.
   */
  quoteAssetId: number;
  /**
   * Trade direction.
   */
  side: ExternalTradeRegistration.SideEnum;
  /**
   * Qty for client(in base asset).
   */
  clientBaseAssetAmount: number;
  /**
   * Volume for client(in quote asset).
   */
  clientQuoteAssetAmount: number;
  /**
   * Qty for LP(in base asset).
   */
  lpBaseAssetAmount: number;
  /**
   * Volume for LP(in quote asset).
   */
  lpQuoteAssetAmount: number;
  /**
   * Trade time, track current time if empty.
   */
  tradeTimestamp?: string;
}
export namespace ExternalTradeRegistration {
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
}
